import { type PropsWithChildren } from 'react';

import styles from '@web/templates/ErrorPages/atoms/MainContent/MainContent.module.scss';

interface Props extends PropsWithChildren {}

export const MainContent = ({ children }: Props) => {
    const deprecatedClass = 'main-content _pb-redesign _including-children';
    const classes = `${styles.MainContent} ${deprecatedClass}`;
    return <div className={classes}>{children}</div>;
};
